var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDice1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 160 160",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M132.505-.018H27.495C12.324-.018-.018 12.324-.018 27.495v105.01c0 15.171 12.342 27.513 27.513 27.513h105.01c15.171 0 27.513-12.342 27.513-27.513V27.495c0-15.171-12.342-27.513-27.513-27.513zm17.513 132.523c0 9.656-7.856 17.513-17.513 17.513H27.495c-9.656 0-17.513-7.856-17.513-17.513V27.495c0-9.656 7.856-17.513 17.513-17.513h105.01c9.656 0 17.513 7.856 17.513 17.513z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80 66.536c-7.436 0-13.464 6.028-13.464 13.465 0 7.436 6.028 13.464 13.464 13.464s13.465-6.028 13.465-13.464C93.464 72.564 87.436 66.536 80 66.536z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDice1);
export default __webpack_public_path__ + "static/media/dice1.cab0dec6816f4751512b1f381a97765d.svg";
export { ForwardRef as ReactComponent };